export default () => ({
  gebruikers: [],
  gebruiker: {}
});
